import { ReactNode } from "react";
import RtlMuiThemeProvider from "./RtlMuiThemeProvider";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { MuiTheme } from "../../theme/MuiTheme";
import { SnackbarProvider } from "notistack";
import { Provider } from "react-redux";
import { store } from "../../redux/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      gcTime: 5 * 60 * 1000,
      refetchInterval: 0,
      staleTime: 30 * 1000,
    },
  },
});

type Props = {
  children: ReactNode;
};

const Providers = ({ children }: Props) => {
  return (
    <Provider store={store}>
      <RtlMuiThemeProvider>
        <ThemeProvider theme={MuiTheme}>
          <CssBaseline />
          <QueryClientProvider client={queryClient}>
            <SnackbarProvider
              maxSnack={3}
              anchorOrigin={{ vertical: "top", horizontal: "left" }}
              autoHideDuration={4000}
            >
              {children}
            </SnackbarProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </RtlMuiThemeProvider>
    </Provider>
  );
};

export default Providers;
